import ROUTE from 'constant/route'

export default function replaceDocumentRoute(category: string, title: string) {
    return ROUTE.DOCUMENT.replace(':category', category).replace(
        ':docTitle',
        title,
    )
}
